import { DelayCodeModel } from "../../Model/DelayCodeModel";

// Define the initial state for the delay codes reducer
const initialState = {
  delayCodes: [] as DelayCodeModel[],
  loading: false,
  error: null as string | null,
};

// The delayCodesReducer function handles actions related to delay codes.
// It takes the current state and an action as arguments and returns a new state based on the action type.
const delayCodesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_DELAY_CODES_REQUEST':
      // When a request to fetch delay codes is made, set loading to true and clear any errors
      return { ...state, loading: true, error: null };
    case 'FETCH_DELAY_CODES_SUCCESS':
      // When delay codes are successfully fetched, update the delayCodes array and set loading to false
      return { ...state, loading: false, delayCodes: action.payload };
    case 'FETCH_DELAY_CODES_FAILURE':
      // When there is an error fetching delay codes, set the error message and set loading to false
      return { ...state, loading: false, error: action.payload };
    default:
      // For any other action types, return the current state
      return state;
  }
};

// This reducer is useful because it manages the state related to delay codes in a predictable way.
// It handles different action types to update the state accordingly, making the state management
// more modular and easier to maintain.

// To add a new reducer, create a similar function that handles the state and actions for a different part of the application.
// Then, combine it with other reducers using combineReducers in the rootReducer.

export default delayCodesReducer;